import React from "react";
import PropTypes from "prop-types";
import pencilIcon from "../../assets/brand/pencil.svg";
import { resolveSize } from "./Icons";

const EditIcon = ({ className = "edit-icon", size = "sm" }) => {
  const resolvedSize = resolveSize(size);
  return (
    <span
      className={className}
      aria-label="Edit"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: resolvedSize,
        height: resolvedSize,
      }}
    >
      <img
        src={pencilIcon}
        alt="edit"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          cursor: "pointer",
        }}
      />
    </span>
  );
};

EditIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
};

export default EditIcon;
